import React, { useEffect, useRef, useState } from 'react';
import useWidgetStore from '../store/useWidgetStore';

export const POPOUT_DIRECTION = {
	TOP: 'top',
	BOTTOM: 'bottom',
};
POPOUT_DIRECTION.DEFAULT = POPOUT_DIRECTION.TOP;

export const usePopoutDirection = (ref, active = true) => {
  const detectPopoutDirection = useWidgetStore((state) => state.detectPopoutDirection);
  const [direction, setDirection] = useState(POPOUT_DIRECTION.DEFAULT);
  const frameId = useRef(null);

  useEffect(() => {
    const handlePosition = () => {
      if (!ref.current || !active || !detectPopoutDirection) return;

      const rect = ref.current?.getBoundingClientRect();
      const midpoint = rect?.top + rect?.height / 2;
      const viewportHeight = window?.innerHeight;
      const newDirection =
        midpoint < viewportHeight / 2 ? POPOUT_DIRECTION.BOTTOM : POPOUT_DIRECTION.TOP;

      setDirection((prev) => {
      	if (newDirection !== prev) {
      		useWidgetStore.getState().setPopoutDirection(newDirection);
      	}
      	return newDirection;
      });
    };

    const onScrollOrResize = () => {
      if (frameId.current !== null) return; // Already queued
      frameId.current = requestAnimationFrame(() => {
        handlePosition();
        frameId.current = null; // Reset after frame runs
      });
    };

    if (detectPopoutDirection) {
      handlePosition();

      window.addEventListener('scroll', onScrollOrResize);
      window.addEventListener('resize', onScrollOrResize);
    }

    return () => {
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
      cancelAnimationFrame(frameId.current);
    };
  }, [ref, active, detectPopoutDirection]);

  return direction;
};
